export const NUMBER_VISIBLE_SLIDES = 8
